import React from 'react';
import {AutoComplete, DatePicker, Form, InputNumber, message, Modal, Select} from 'antd';

class LeaseAsset extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      asset: '',
      loc: '',
      from: '',
      to: '',
      lfrom: '',
      lto: '',
      ramount: 0,
    };
  }

  onCancel = () => {
    this.props.showToggle(this.props.data._id);
  }

  onChange = (value, name) => {
    if(name === 'asset')
      this.setState({
        asset: value
      });
    if(name === 'loc')
      this.setState({
        loc: value
      });
    if(name === 'from')
      this.setState({
        from: value
      });
    if(name === 'to')
      this.setState({
        to: value
      });
    if(name === 'lfrom')
      this.setState({
        lfrom: value
      });
    if(name === 'lto')
      this.setState({
        lto: value
      });
    if(name === 'ramount')
      this.setState({
        ramount: value
      });
  };

  validate = () => {
    const {list: currentData} = this.props;
    const {asset} = this.state;
    const checkedAssets = []; // currentData.map(item => item.leasingAsset._id === asset)
    if(checkedAssets && checkedAssets.length > 0 && checkedAssets.includes(true)) {
      message.error('Asset already exist');
      return false;
    }
    return true;
  }

  ObjectId = (m = Math, d = Date, h = 16, s = s => m.floor(s).toString(h)) =>
    s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h));

  onCreate = () => {
    const {asset, loc, lfrom, lto, from, to, ramount} = this.state;
    if(asset && loc && lfrom && lto && from && to && this.validate()) {
      this.props.updateAssets(this.props.data._id, null, 'new', {
        asset: {
          id: this.ObjectId(),
          leasingAsset: asset,
          location: loc,
          periodFrom: from,
          periodTo: to,
          lockInPeriodFrom: lfrom,
          lockInPeriodTo: lto,
          residualAmount: ramount ? ramount : 0,
        }
      });
      this.onCancel();
    } else console.log('Error ')
  }

  disabledDate = (current) => {
    const {data} = this.props;
    const fromDate = data.agreementPeriodFrom;
    const toDate = data.agreementPeriodTo;
    // return current && !moment(current).isBetween(moment(fromDate).startOf('day'), moment(toDate).endOf('day'));
    return !current; // && !moment(current).isBetween(moment(fromDate).startOf('day'), moment(toDate).endOf('day'));
  }

  render() {
    const {visible, onCreate, form, locations} = this.props;
    return (
      <div>
        <Modal
          visible={visible}
          title="Add new Asset"
          okText="Save"
          onCancel={this.onCancel}
          onOk={this.onCreate}
        >
          <Form layout="vertical">
            <Form.Item key={`asset`} label={'Enter Asset'} style={{width: '100%'}}>

              <AutoComplete onSearch={this.props.assetSearch} onChange={(e) => this.onChange(e, 'asset')}
                            placeholder={'Asset Code'}>
                {
                  (this.props.assetData || []).map(item => (
                    <Select.Option key={item._id} value={item._id}>{item.assetCode}</Select.Option>))
                }
              </AutoComplete>
            </Form.Item>

            <Form.Item key={`loc`} label={'Location'} style={{width: '100%'}}>
              <Select showSearch
                      allowClear
                      placeholder={`Please Select Location`}
                      onChange={(e) => this.onChange(e, 'loc')}
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }>
                {locations.map(item => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item key={`from`} label={'Period From'} style={{width: '100%'}}>
              <DatePicker disabledDate={this.disabledDate} onChange={(e) => this.onChange(e, 'from')}/>
            </Form.Item>

            <Form.Item key={`to`} label={'Period To'} style={{width: '100%'}}>
              <DatePicker disabledDate={this.disabledDate} onChange={(e) => this.onChange(e, 'to')}/>
            </Form.Item>

            <Form.Item key={`lfrom`} label={'Lock-In Period From'} style={{width: '100%'}}>
              <DatePicker disabledDate={this.disabledDate} onChange={(e) => this.onChange(e, 'lfrom')}/>
            </Form.Item>

            <Form.Item key={`lto`} label={'Lock-In Period To'} style={{width: '100%'}}>
              <DatePicker disabledDate={this.disabledDate} onChange={(e) => this.onChange(e, 'lto')}/>
            </Form.Item>

            <Form.Item key={`ramount`} label={'Residual Amount'} style={{width: '100%'}}>
              <InputNumber onChange={(e) => this.onChange(e, 'ramount')}/>
            </Form.Item>

          </Form>
        </Modal>
      </div>
    );
  }
}

export default LeaseAsset;
